import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusSquare } from '@fortawesome/pro-light-svg-icons';
import { faPlusSquare as faPlusSquareSolid } from '@fortawesome/pro-solid-svg-icons';

import styles from './index.module.scss';
import Tooltip from 'src/common/Tooltip';
import { useTranslation } from 'react-i18next';
import { Spinner } from 'src/common';
import classNames from 'classnames';
import WSLabel from '../WSLabel';
import { IBidIdentifier } from 'src/models/bids/Bids/types';

interface IProps {
  bid?: IBidIdentifier;
  onVisibleChange: () => void;
  isUpdating: boolean;
  isActive: boolean;
  showTooltip?: boolean;
}

const BidPickerShortModeAction: FC<IProps> = props => {
  const { bid, onVisibleChange, showTooltip, isUpdating, isActive } = props;
  const { t } = useTranslation();

  return (
    <Tooltip title={showTooltip ? t('BidSpaces.connectToBidOrAddToBidSpace') : undefined}>
      <button onClick={onVisibleChange} className={classNames(styles.button, { [styles.isActive]: isActive })}>
        {isUpdating && <Spinner className={styles.spinner} />}
        {!!bid && !isUpdating && <WSLabel bid={bid} mode={'short'} />}
        {!bid && !isUpdating && (
          <>
            <FontAwesomeIcon icon={faPlusSquare} className={classNames(styles.icon, styles.buttonIcon)} />
            <FontAwesomeIcon icon={faPlusSquareSolid} className={classNames(styles.icon, styles.hoveredButtonIcon)} />
          </>
        )}
      </button>
    </Tooltip>
  );
};

export default BidPickerShortModeAction;
